<template>

  <div class="kw_preview_image" :style="styleSet.pageFieldStyleSet?styleSet.pageFieldStyleSet.styleSetCode:''" kwName="pageFieldStyleSet">
    <!-- 可预览 -->
    <div v-if="(styleSet.imgPreview == 2 || styleSet.imgPreview == 3)"  style="position:relative">
      <viewer :images="imgList">
        <img v-for="(src,srcIndex) in imgList" :key="'imageSrc_'+srcIndex" :src="src"  :class="zdyClass" style="width: 100%" :style="styleSet.pageFieldImageStyleSet?styleSet.pageFieldImageStyleSet.styleSetCode:''" kwName="pageFieldImageStyleSet">
      </viewer>
      <span v-if="(styleSet.imgPreview == 3)" class="checkLook" style="pointer-events:none" :style="styleSet.pageFieldValueStyleSet?styleSet.pageFieldValueStyleSet.styleSetCode:''" kwName="pageFieldValueStyleSet">点击查看详情</span>
    </div>
    <!-- 不可预览 -->
    <template v-else>
      <img v-for="(src,srcIndex) in imgList" :key="'imageSrc_'+srcIndex" :src="src" class="img_style" :class="zdyClass" :style="styleSet.pageFieldImageStyleSet?styleSet.pageFieldImageStyleSet.styleSetCode:''" kwName="pageFieldImageStyleSet" :mode="styleSet.pageFieldImageStyleSet&&styleSet.pageFieldImageStyleSet.height?'':'widthFix'"/>
    </template>
  </div>
</template>

<script>
export default {
  name: 'kw_preview_image',
  props: {
    item: {
      type: Object,
      default: null
    },
    styleSet: {
      type: Object,
      default: null
    },
    imgSrc: {
      type: String,
      default: null
    },
    imgSrcArr: {
      type: Array,
      default: null
    },
    zdyClass:{
      type: String,
      value: 'RankingImg'
    }
  },
  data() {
    return {
      imgList:[]
    };
  },
  created() {
    this.initA();
  },
  mounted() {
  },
  watch:{
    imgSrc:function(){
      this.initA();
    },
    imgSrcArr:function(){
      this.initA();
    }
  },
  computed:{
  },
  components: {
  },
  methods: {
    initA() {
      var that = this;
      var imgSrcArr = that.imgSrcArr;
      var fileServeUrl = this.GLOBAL.getFileServeUrl();
      var arr = []
      if (imgSrcArr && imgSrcArr.length > 0) {
        imgSrcArr.forEach(one=>{
          arr.push(one.startsWith("http")?one:fileServeUrl+one)  
        })
      } else if(that.imgSrc) {
        if(that.imgSrc.indexOf(",")>0) {
          var tmpImgArr = that.imgSrc.split(",");
          for (let index = 0; index < tmpImgArr.length; index++) {
            const element = tmpImgArr[index];
            arr.push(element.startsWith("http")?element:(fileServeUrl+element));
          }
        } else {
          arr.push(that.imgSrc.startsWith("http")?that.imgSrc:(fileServeUrl+that.imgSrc));
        }
      }
      that.imgList = arr;
    },
    /**
     * 点击文字时触发 图片的预览点击事件
     */
    imgYu(){
//      console.log(this.$refs.el_image);
//      this.$refs.el_image.clickHandler();
    }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .kw_preview_image{background: #fff}
.RankingImg{width: 100%;display: block}
.checkLook{
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  height:32px;
  background:#000;
  opacity:0.5;
  color:#fff;
  width:110px;
  text-align:center;
  font-size:16px;
  line-height:32px;
  border-radius:32px;
  margin: auto;
}
.commentImg{height: 70px;width: 90px}
.imageStyle{display: block;width: 100%;padding: 10px}
  .img_style{width: 100%}
</style>
